export const INITIATED = 'Initiated';
export const LAST_UPDATED = 'Last updated';
export const BANK_IBAN = 'Bank/IBAN';
export const CUSTOMER = 'Customer';
export const DESCRIPTION = 'Description';
export const REFERENCE = 'Transaction ref.';
export const AMOUNT = 'Amount';
export const STATUS = 'Status';
export const RECONCILIATION_REFERENCE = 'Reconciliation ref.';
export const ACTIONS = 'actions-column';
